import {Button} from 'antd'
import ItemsTable from './items-table'
import {StackedBars} from './stacked-bars'
import {createMapIcon} from 'helpers/images'

const getRowKey = record => {
  return `${record?.id}`
}

// prettier-ignore
const getColumns = handleItemClick => [
{
  title: 'Name',
  render: (_, record, index) => {
    let name = record.name
    let icon = null

    if (record.mapKey !== undefined) {
      const size = 20 // Smaller size of the marker
      const encodedSvg = createMapIcon(record.mapKey, size, 12, 'white', 'red', 2, 'red')
      icon = (
        <img
          src={encodedSvg}
          alt=""
          style={{width: size, height: size, marginRight: 0, verticalAlign: 'middle'}}
        />
      )
    }

    return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <Button
          type="link"
          onClick={e => {
            e.stopPropagation()
            handleItemClick(record)
          }}
        >
          {icon}
          {name}
        </Button>
      </div>
    )
  }
},
  {
    title: 'Targets Status',
    key: 'tg_status',
    render: (text, row) => <StackedBars data={getSeries(row)} />,
    align: 'center'
  }
]

const getSeries = item => {
  return [
    item.tg_status_none_count,
    item.tg_status_offline_count,
    item.tg_status_online_count,
    item.tg_status_normal_count,
    item.tg_status_warning_count,
    item.tg_status_critical_count,
    item.tg_status_error_count
  ]
}

const TargetStatusTable = ({items, pagination, handleItemClick, rowKeyFunc = getRowKey, columnsFunc = getColumns}) => {
  return items ? (
    <ItemsTable
      items={items}
      handleItemClick={handleItemClick}
      pagination={pagination}
      rowKeyFunc={rowKeyFunc}
      columnsFunc={columnsFunc}
    />
  ) : (
    <></>
  )
}

export default TargetStatusTable
